import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { useRef } from "react";
import { BarChart, Bar, XAxis, YAxis, ResponsiveContainer, Tooltip } from "recharts";
import { predefinedActionTypes } from "../utils/chartUtils";
import { getActionColor } from "../utils/networkErrorsUtils";
export const NetworkErrorsChart = ({ volumeChartData, chartGranularity, interactions, onChartDoubleClick, }) => {
    const chartRef = useRef(null);
    const handleChartDoubleClick = (data) => {
        if (data && data.activeLabel && onChartDoubleClick) {
            const period = data.activeLabel;
            const periodInteractions = interactions.filter((interaction) => {
                if (!interaction.InteractionStartDateUtc)
                    return false;
                const date = new Date(interaction.InteractionStartDateUtc);
                if (isNaN(date.getTime()))
                    return false;
                let periodKey = "";
                switch (chartGranularity) {
                    case "Hourly":
                        periodKey = `${date.getMonth() + 1}/${date.getDate()} ${String(date.getHours()).padStart(2, "0")}:00`;
                        break;
                    case "Daily":
                        periodKey = `${date.getMonth() + 1}/${date.getDate()}`;
                        break;
                    case "Weekly":
                        const weekStart = new Date(date);
                        weekStart.setDate(date.getDate() - date.getDay());
                        periodKey = `${weekStart.getMonth() + 1}/${weekStart.getDate()}`;
                        break;
                }
                return periodKey === period;
            });
            onChartDoubleClick({ activeLabel: period, interactions: periodInteractions });
        }
    };
    if (volumeChartData.length === 0) {
        return null;
    }
    return (_jsxs("div", { className: "network-errors-chart-section", children: [_jsxs("h3", { className: "network-errors-chart-title", children: ["Volume by ", chartGranularity === "Hourly" ? "Hour" : chartGranularity === "Daily" ? "Day" : "Week"] }), _jsx("div", { ref: chartRef, className: "network-errors-chart-container", children: _jsx(ResponsiveContainer, { width: "100%", height: "100%", children: _jsxs(BarChart, { data: volumeChartData, margin: { top: 5, right: 30, left: 20, bottom: 5 }, onDoubleClick: handleChartDoubleClick, children: [_jsx(XAxis, { dataKey: "period", tick: { fontSize: 10 }, interval: 0, angle: -45, textAnchor: "end", height: 60 }), _jsx(YAxis, { tick: { fontSize: 10 } }), _jsx(Tooltip, { content: ({ active, payload, label }) => {
                                    if (active && payload && payload.length) {
                                        const nonZeroData = payload.filter((entry) => entry.value && typeof entry.value === "number" && entry.value > 0 && entry.dataKey !== "total");
                                        if (nonZeroData.length === 0)
                                            return null;
                                        const total = nonZeroData.reduce((sum, entry) => sum + entry.value, 0);
                                        return (_jsxs("div", { style: {
                                                backgroundColor: "rgba(255, 255, 255, 0.98)",
                                                border: "1px solid #ccc",
                                                borderRadius: "8px",
                                                fontSize: "13px",
                                                padding: "12px",
                                                boxShadow: "0 4px 12px rgba(0, 0, 0, 0.2)",
                                                zIndex: 100,
                                                position: "relative",
                                                minWidth: "200px",
                                            }, children: [_jsx("div", { style: {
                                                        margin: "0 0 8px 0",
                                                        fontWeight: "bold",
                                                        color: "#374B94",
                                                        fontSize: "14px",
                                                    }, children: label }), _jsxs("div", { style: {
                                                        fontSize: "12px",
                                                        color: "#666",
                                                        marginBottom: "8px",
                                                    }, children: [_jsx("strong", { children: "Total:" }), " ", total.toLocaleString()] }), nonZeroData
                                                    .sort((a, b) => b.value - a.value)
                                                    .map((entry, index) => {
                                                    const percentage = ((entry.value / total) * 100).toFixed(1);
                                                    return (_jsx("div", { style: { marginBottom: "4px" }, children: _jsxs("div", { style: {
                                                                display: "flex",
                                                                alignItems: "center",
                                                                justifyContent: "space-between",
                                                            }, children: [_jsxs("span", { style: {
                                                                        fontWeight: "600",
                                                                        color: "#333",
                                                                    }, children: [entry.dataKey, ":"] }), _jsxs("span", { style: {
                                                                        fontWeight: "bold",
                                                                        color: entry.color,
                                                                    }, children: [entry.value, " (", percentage, "%)"] })] }) }, index));
                                                })] }));
                                    }
                                    return null;
                                } }), predefinedActionTypes.map((action) => (_jsx(Bar, { dataKey: action, stackId: "a", fill: getActionColor(action) }, action)))] }) }) })] }));
};
//# sourceMappingURL=NetworkErrorsChart.js.map